import {Component, Input, OnInit} from '@angular/core';
import {SmartDoorActivityPayloadAccess} from '@model/product/smart-door/activity/payload/smart-door-activity-payload-access.model';
import {SmartDoorActivityPayloadSchedule} from '@model/product/smart-door/activity/payload/smart-door-activity-payload-schedule.model';
import {SmartDoorActivityPayloadPreviousMode} from '@model/product/smart-door/activity/payload/smart-door-activity-payload-previous-mode.model';

@Component({
  selector: 'app-smartdoor-activity-payload',
  templateUrl: './smartdoor-activity-payload.component.html',
  styleUrls: ['./smartdoor-activity-payload.component.scss']
})
export class SmartdoorActivityPayloadComponent implements OnInit {
  @Input()
  payload: SmartDoorActivityPayloadAccess | SmartDoorActivityPayloadSchedule | SmartDoorActivityPayloadPreviousMode;

  constructor() { }

  ngOnInit() {
  }

  PayloadType(): string {
    if (!this.payload) {
      return null;
    }
    if ('previousMode' in this.payload) {
      return 'PreviousMode';
    } else if ('scheduleId' in this.payload) {
      return 'Schedule';
    } else {
      return 'Access';
    }
  }

  Access(access: number): string {
    switch (access) {
      case 0:
        return 'NO ACCESS';
      case 1:
        return 'OUT ONLY';
      case 2:
        return 'IN ONLY';
      case 3:
        return 'FULL ACCESS';
    }
    return null;
  }
}
